import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { FaInfo } from "react-icons/fa";

const Hover = ({ data }) => {
    return (
        <Grid item>
            <Tooltip disableFocusListener disableTouchListener title={data} classes={{ tooltip: "tooltip_main_class" }}>
                <Button className="tootltip_icon_button"><FaInfo /></Button>
            </Tooltip>
        </Grid>
    );
}

export default Hover;